module.exports = __webpack_public_path__ + "media/site_templates/www.exterminators.net.au/images/about_us-639ae86516da83cff4b96845a1c33f3e.jpg";